import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiForumPostEditComponent } from './fi-forum-post-edit.component';
import { FiForumPostAddComponent } from './fi-forum-post-add.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiTextEditorSharedModule } from '@fi-shared/fi-text-editor/fi-text-editor-shared.module';
import { FormsModule } from '@angular/forms';
import { FiForumPostAddContainerComponent } from './fi-forum-post-add-container.component';
import { MatCardModule } from '@angular/material/card';
import { FiForumPostAddScreenComponent } from './fi-forum-post-add-screen.component';
import { FicScreenModule } from '@fi-shared/fic-screen/fic-screen.module';
import { FiButtonBackNewModule } from '@fi-shared/fi-button-back-new/fi-button-back-new.module';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@NgModule({
    imports: [
        CommonModule,
        FiAppTextSharedModule,
        FiTextEditorSharedModule,
        FormsModule,
        MatCardModule,
        FicScreenModule,
        FiButtonBackNewModule,
        SelectSearchModule,
        MatFormFieldModule,
        MatInputModule,
    ],
    declarations: [
        FiForumPostEditComponent,
        FiForumPostAddComponent,
        FiForumPostAddContainerComponent,
        FiForumPostAddScreenComponent,
    ],
    exports: [FiForumPostAddComponent, FiForumPostEditComponent],
})
export class FiForumPostEditModule {}
